import { render } from "./markdown.vue?vue&type=template&id=28729082&ts=true"
import script from "./markdown.vue?vue&type=script&lang=ts"
export * from "./markdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__